<template>
    <div class="container feedback template-bg-gray"  v-bind:class="{'my-position-relative': isStatus}">
        <md-card class="request-status loop_container bg-transparent update-request-form-common" v-if="isStatus">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-html="statusMsg"></h4>
                </div>
             </md-card-content>
	    </md-card>
        <div class="row" v-if="!isStatus">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div class="card form-wrapper thankupageplr88">
                        <div class="feedback_container">
                            <div class="community-logo" v-if="logoURL">
                                <img :src="logoURL" :alt="imgAlt"  class="top-logo custom-logo">
                            </div>
                            <div class='header-text text-center common-space-from-logo'>
                                <h1 class="template-title" role="alert" aria-live="assertive">{{message}}</h1>
                                <div class="custome-width-500 plr10">
                                </div>
                            </div>
						</div>
                    </div>
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use [pdf]</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                        </li>
                        <li>
                            <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                            <a href="javascript:void(0)" v-else>Opt Out</a>
                        </li>
                    </ul>
                    <div class="unsubscribe-community-logo">
                        <a href="https://www.protopia.co" target="_blank"><img :src="this.footerLogoURL" alt='Community Logo'></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from "../services/API";
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";
export default {
    name: 'requestSnooze',
     props: ["memberid", "askid"],
    data() {
        return {
            fullPage: true,
            api: new API(),
            message: '',
            community: {},
            ask: {},
            isStatus: true,
            statusMsg: '',
            logoURL: '',
            imgAlt: 'Community Logo',
            footerLogo: "",
            footerLogoURL: ""
        }
    },
    beforeCreate() {
        if (!this.$route.query.askid || !this.$route.query.memberid) {
            this.$router.push('/');
        }
    },
    async created() {
        await this.api.post(`asks/request-snooze`, {askId: this.$route.query.askid, adviserId: this.$route.query.memberid}).then(response => {
            if (response.data && response.data.ask) {
                this.ask = response.data.ask;
                if (this.ask.status === '(8) Rejected' || this.ask.status === '(7) Closed') {
                    // console.log("this.community :", this.ask.community);
                    let closeMessage = this.ask.community.content.closeRequestMessage;
                    this.statusMsg = closeMessage;
                } else {
                    this.isStatus = false;
                }
                this.community = this.ask.community;
                const customSettings = this.community.customSettings;
                if (this.community && this.community.content.parameter2) {
                    this.imgAlt = this.community.content.parameter2;
                }
                this.message = "Thank you!";
                if (response.data.status) {
                    this.message = this.community.content.snoozeMessage;
                }
                this.logoURL = getLogoURL(customSettings);
                this.footerLogoURL = getFooterURL(customSettings);
            } else {
                this.message = "Thank you!";
            }
            window.scrollTo(0, 0);
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/requestSnooze.vue